module.exports = __webpack_public_path__ + "static/media/no-entry-sign-1145042-638x422.e548db43.jpg";